import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import ErrorBoundary from './components/layout/ErrorBoundary'
import './styles/globals.css'
import { prepareScreens } from './i18n/render'

// The dictionary of the person's language is at hand before the first screen is built.
void prepareScreens().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  )
})
